import {
  SET_ISTABLET,
  CLEAR_ISTABLET,
  SET_NO_SKIP_COUNT,
  CLEAR_NO_SKIP_COUNT
} from "./type";

// set isTablet state
export const setIsTablet = (isTablet) => ({
  type: SET_ISTABLET,
  payload: isTablet
});

// clear isTablet state
export const clearIsTablet = () => ({
  type: CLEAR_ISTABLET
});

// set noSkipCount state (when Booksets is first to encounter isTablet)
export const setNoSkipCount = (noSkipCount) => ({
  type: SET_NO_SKIP_COUNT,
  payload: noSkipCount
});

// clear noSkipCount state
export const clearNoSkipCount = () => ({
  type: CLEAR_NO_SKIP_COUNT
});
